export default __webpack_public_path__ + "static/media/welcome.bcca59fe.png";